import type { ReactNode } from "react";

/**
 * 空状态。
 *
 * spec 反复强调空状态**不能是空白页**：首页要说「今天 TA 还没有想跟你说的话」，
 * 纪念日 tab 要给出引导。所以这个组件是必选件而不是可选件。
 */
export function Empty({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="empty">
      {icon !== undefined && <div className="em-ico">{icon}</div>}
      <div className="em-t">{title}</div>
      {description !== undefined && <div className="em-d">{description}</div>}
      {action}
    </div>
  );
}
